import styled from 'styled-components';

export const Body = styled.div`
  .campo-label {
    font-weight: 700;
    color: ${(props) => props.theme.$gray800};
  }

  .campo-valor {
    margin-bottom: 12px;
    color: ${(props) => props.theme.$gray600};
    overflow-wrap: anywhere;
  }

  .amostra-desc {
    font-size: 1rem;
    font-weight: 500;
    color: ${(props) => props.theme.$gray900};
    margin-bottom: 12px;
  }

  .amostra-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 10px;
    margin-bottom: 14px;

    div {
      border: 1px solid ${(props) => props.theme.$gray300};
      border-radius: 8px;
      background: ${(props) => props.theme.$gray100};
      padding: 8px 10px;
    }

    span {
      display: block;
      font-size: 0.74rem;
      color: ${(props) => props.theme.$gray600};
    }

    strong {
      font-size: 0.92rem;
      color: ${(props) => props.theme.$gray900};
    }
  }

  .amostra-edital {
    border-left: 3px solid ${(props) => props.theme.$primary_green};
    padding-left: 12px;

    .amostra-edital-title {
      font-size: 0.8rem;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.04em;
      color: ${(props) => props.theme.$gray600};

      span {
        display: inline-flex;
        align-items: center;
        gap: 3px;
        margin-left: 8px;
        text-transform: none;
        letter-spacing: 0;
        font-weight: 500;
        color: ${(props) => props.theme.$dark_green};
      }

      i {
        font-size: 14px;
      }
    }
  }

  .secao-titulo {
    margin: 0 0 8px;
    font-size: 0.8rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: ${(props) => props.theme.$gray600};
  }

  .anexos {
    margin-bottom: 12px;

    .campo-label {
      display: block;
      margin-bottom: 4px;
    }
  }

  .resultados {
    max-height: 360px;

    thead th {
      position: sticky;
      top: 0;
      background: ${(props) => props.theme.$gray100};
      font-size: 0.78rem;
      white-space: nowrap;
    }

    td {
      font-size: 0.85rem;
      vertical-align: top;
    }

    tr.destaque td {
      background: ${(props) => props.theme.$bg_green};
      font-weight: 500;
    }
  }
`;
